gx-query-viewer-chart-controller,
.gx-query-viewer-chart-controller__timeline-container {
  display: grid;
  grid-auto-rows: calc(100% / var(--gx-query-viewer-chart-count));
}

.gx-query-viewer-controller--timeline {
  grid-template-rows: min-content 1fr min-content;
  width: 100%;
}

.gx-query-viewer-chart-controller__header {
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-template-rows: min-content;
}

.gx-query-viewer-chart-controller__header-compare-container {
  display: grid;
  grid-template-columns: min-content 1fr;
  & > gx-checkbox > .gx-checkbox__container {
    margin: 2px;
  }

  & > gx-select {
    background-color: inherit;
  }
}

.gx-query-viewer-chart-controller__header-form-field {
  width: max-content;
  justify-self: center;
  --gx-form-field-label-width-column: max-content;
}

.gx-query-viewer-chart-controller__header-zoom-options {
  display: flex;
}

.gx-query-viewer-chart_timeline-footer {
  width: 100%;
}

.gx-query-viewer-chart-controller__header-zoom-button {
  &--checked {
    .label-of-the-option {
      text-decoration: underline;
    }
  }
  .option-and-label-container {
    .option-container {
      display: none;
    }

    .label-of-the-option {
      padding-inline: 7px;
      cursor: pointer;
    }
  }
}
